
    import {defineComponent} from 'vue';
    import {bool, string} from 'vue-types';

    export default defineComponent({
        name: 'StepItemTitle',
        props: {
            isOptional: bool().def(false),
            dataTestid: string(),
        },
    });
